import { api } from "@/api/client";
import { QualifierUser } from "../user";
import { GlobalSearchResult } from "./search";

export enum AccessLevel {
  GeneralUser,
  WeldingInspector,
  WeldingSpecialist,
  AIWeldingSME,
  Administrator,
}

export type WilliamsRoles = {
  administrator: boolean;
  aIWeldingSME: boolean;
  weldingSpecialist: boolean;
  weldingInspector: boolean;
  generalUser: boolean;
};

export type UserPermissions = {
  accessLevel: AccessLevel;
};

export type TransferRequest = {
  transferFrom: QualifierUser;
  transferTo: QualifierUser;
  items: GlobalSearchResult[];
};

export function getUserRoles() {
  return api.get<WilliamsRoles>("williams/user/roles");
}

export function getPermissions() {
  return api.get<UserPermissions>("williams/user/permissions");
}

export function getWeldingSpecialists() {
  return api.get<QualifierUser[]>("williams/user/specialists");
}

export function getUserLookup(search: string) {
  return api.get<QualifierUser[]>(`williams/user/lookup?search=${search}`);
}

export function transferOwner(request: TransferRequest) {
  return api.post("williams/user/transfer/ownership", request);
}

export function transferSpecialist(request: TransferRequest) {
  return api.post("williams/user/transfer/specialist", request);
}
